import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "controlly_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch { /* localStorage unavailable */ }
  }, []);

  const choose = (value) => {
    try { localStorage.setItem(STORAGE_KEY, value); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:bottom-6 z-[60] sm:max-w-sm rounded-xl border border-white/10 bg-zinc-900/95 backdrop-blur-md shadow-2xl p-4 animate-in slide-in-from-bottom-4 fade-in duration-500"
    >
      <div className="flex items-start gap-3">
        <div className="grid place-items-center w-8 h-8 rounded-full bg-primary/10 text-primary shrink-0">
          <Cookie size={16} weight="fill" />
        </div>
        <div className="min-w-0">
          <p className="text-sm text-zinc-200 font-medium">We use essential cookies</p>
          <p className="text-xs text-zinc-400 leading-relaxed mt-1">
            Controlly uses a secure session cookie to keep you signed in. We don't use ads or cross-site tracking.{" "}
            <Link to="/cookies" className="text-blue-400 hover:text-blue-300 underline underline-offset-2" data-testid="cookie-consent-learn-more">
              Learn more
            </Link>.
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 mt-3">
        <Button
          data-testid="cookie-consent-accept"
          onClick={() => choose("accepted")}
          className="flex-1 h-9 bg-blue-600 hover:bg-blue-500 text-sm"
        >
          Accept
        </Button>
        <Button
          data-testid="cookie-consent-dismiss"
          onClick={() => choose("dismissed")}
          variant="outline"
          className="h-9 bg-transparent border-white/10 hover:bg-zinc-800 text-sm text-zinc-300"
        >
          Dismiss
        </Button>
      </div>
    </div>
  );
}
